module.exports = __webpack_public_path__ + "static/media/ai-ad-elsayed-thumbnailDT.8e1979b5.png";